import React from 'react'

export default function Loding() {
  return (
    <div className='loding'>
        <img src="./image/loader.gif" alt="nscjx" />
    </div>
  )
}
